<template>
  <div class="content container-fluid">
    <!-- Popover for Filter -->
    <popover
      name="popFilename"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranFilename"
        :options="colFilter.tranFilenameColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- /Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Logs</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <div class="row align-items-center mt-2">
      <div class="col-md-2">Month</div>
      <div class="col-md-2 pl-md-0">
        <select class="custom-select" v-model="month">
          <option value="">All</option>
          <option v-for="month in months" :key="month" :value="month">
            {{ month }}
          </option>
        </select>
      </div>

      <div class="col-md-2"></div>

      <div class="col-md-2 ml-md-4">Year</div>
      <div class="col-md-2 pl-md-0">
        <select class="custom-select" v-model="year">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
    </div>

    <div class="row align-items-center mt-3">
      <div class="col-md-12">
        <button type="submit" class="btn btn-primary" @click="getLogs">
          Search
        </button>
      </div>
    </div>
    <!-- /Form -->

    <!-- Pagination -->
    <div class="row mt-4">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-2">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="date-column">
                  <button class="btn p-0" @click="setSortBy('processedDate')">
                    Processed Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'processedDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'processedDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th class="filename-column">
                  <i
                    class="fa fa-filter"
                    v-popover:popFilename
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranFilename.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('filename')">
                    Filename
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'filename'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'filename_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>Log</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in logs" :key="index">
                <td class="date-column">{{ data.ProcessedDateDisplay }}</td>
                <td class="filename-column">{{ data.Filename }}</td>
                <td v-html="formatLogText(data.Log)"></td>
              </tr>

              <tr v-if="logs && !logs.length">
                <td colspan="3" class="text-center">{{ this.noRecordText }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="logs && logs.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          logs.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
  data() {
    return {
      logs: [],
      month: "",
      year: "",
      months: [],
      years: [],
      noRecordText: config.NO_RECORD_TEXT,

      //for pagination
      searchColFilter: {
        tranFilename: [],
      },
      colFilter: {},
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    searchFilter() {
      return [{ name: "tranFilename", val: this.searchColFilter.tranFilename }];
    },
  },

  watch: {
    "searchColFilter.tranFilename": function (val, oldVal) {
      this.getLogs();
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getLogs();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    formatLogText(text) {
      return text.replace(/\n/g, "<br>");
    },
    getYears() {
      let date = new Date();
      let minYear = date.getFullYear() - 5;
      this.years = [];
      for (let year = date.getFullYear(); year > minYear; year--) {
        this.years.push(year);
      }
    },
    getMonths() {
      this.months = [];
      this.month = "";

      this.months.push("Jan");
      this.months.push("Feb");
      this.months.push("Mar");
      this.months.push("Apr");
      this.months.push("May");
      this.months.push("Jun");
      this.months.push("Jul");
      this.months.push("Aug");
      this.months.push("Sep");
      this.months.push("Oct");
      this.months.push("Nov");
      this.months.push("Dec");
    },
    getLogs() {
      let param = {
        Token: this.token,
        Month: this.month,
        Year: this.year,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
      };
      this.$store.state.isLoading = true;
      API.getTimesheetLogs(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.logs = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.colFilter = response.data.colFilter;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getLogs();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getLogs();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getLogs();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getLogs();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getLogs();
    },
    setSortBy(payload) {
      switch (payload) {
        case "filename":
          if (this.paging.SortBy === "filename") {
            this.paging.SortBy = "filename_desc";
          } else if (this.paging.SortBy === "filename_desc") {
            this.paging.SortBy = "filename";
          } else {
            this.paging.SortBy = "filename";
          }
          break;
        case "processedDate":
          if (this.paging.SortBy === "processedDate") {
            this.paging.SortBy = "processedDate_desc";
          } else if (this.paging.SortBy === "processedDate_desc") {
            this.paging.SortBy = "processedDate";
          } else {
            this.paging.SortBy = "processedDate";
          }
          break;
      }
      this.getLogs();
    },
  },

  created() {
    if (this.role == "admin") {
      this.getMonths();
      this.getYears();

      let date = new Date();
      this.month = this.months[date.getMonth()];
      this.year = date.getFullYear();

      this.getLogs();
    }
  },
};
</script>

<style scoped>
.date-column {
  width: 15%;
}

.filename-column {
  width: 25%;
}
</style>


// WEBPACK FOOTER //
// src/components/Attendance/CADOLog.vue